module.exports = __webpack_public_path__ + "static/media/ramp.96062250.svg";